import type { Article } from "../../types/article";
import NewsCard from "./NewsCard";

type Props = {
    articles: Article[];
};

export default function LatestNewsGrid({ articles }: Props) {
    return (
        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {articles.map((article) => (
                <NewsCard key={article.id} article={article} />
            ))}
        </div>
    );
}